// extracted by mini-css-extract-plugin
export default {"paymentAlert":"payment-alert_paymentAlert__ZllKd","title":"payment-alert_title__hHCYX","icon":"payment-alert_icon__FazvB","button":"payment-alert_button__S7jWd"};